module.exports = __webpack_public_path__ + "img/img_tab_1.b7215e94.png";